import RequestCache from "./RequestCache";
//import RequestAbstract from "./RequestAbstract";

export default class RecommendationTypes extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.recommendationTypes;
    }

    async getAll() {
        const arr = [
            { field: "enabled", op: "=", value: true },
        ];
        return await this.getAllFiltered([arr], this.getSortField("title"));
    }
}
